// The renewal premium (spec C12: Rwd Premium comes from the dec page; spec C10: a correction is
// used everywhere). One function for the server and the web (S14), so the list Change column, the
// Increase tag, the Increases to look over card and filter, the Record and the compare panel all
// use the same number.

export type RenewalPremiumSource = 'corrected' | 'dec_page' | 'ams360';

export type RenewalPremium = { value: number; source: RenewalPremiumSource };

/**
 * The VA's corrected value if there is one, else the value read from the dec page, else AMS360's
 * renewed premium. Null when none is known.
 */
export function renewalPremiumOf(p: {
  corrected: number | null;
  read: number | null;
  ams: number | null;
}): RenewalPremium | null {
  if (p.corrected !== null) return { value: p.corrected, source: 'corrected' };
  if (p.read !== null) return { value: p.read, source: 'dec_page' };
  if (p.ams !== null) return { value: p.ams, source: 'ams360' };
  return null;
}
